import { Transportation, TransportPropName } from '../../../../models/project/ghg-emission/transportation.model';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { ValidationInterface } from '../../validation.interface';

export class TransportationValidation implements ValidationInterface {
  /** The current transportation obj that is being validated */
  transportation: Transportation;

  /**
   * Sets the transportation obj that will be used for validation
   * @param transportation will be used to set the current transportation obj
   */
  constructor(transportation: Transportation) {
    if (!transportation) throw Error('invalid transportation provided for validation');
    this.transportation = new Transportation(transportation);
  }

  /**
   * Get a validation unit containing the validation data for the current transportation obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.transportation) throw Error('unable to validate transportation');
    const validationUnit = new ProjectValidationUnit();
    validationUnit.addModuleResults(
      new UnitValueValidation(this.transportation.fuelQuantity).getValidation(),
      TransportPropName.fuelQuantity
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.transportation.fuelPer).getValidation(),
      TransportPropName.fuelPer
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.transportation.fuelUsageIncrease).getValidation(),
      TransportPropName.fuelUsageIncrease
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.transportation.numVehicles).getValidation(),
      TransportPropName.numVehicles
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.transportation.distanceChange).getValidation(),
      TransportPropName.distanceChange
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.transportation.distancePer).getValidation(),
      TransportPropName.distancePer
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current transportation obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
